// Ubicación en el repo: src/components/SendReminderModal.jsx
// Confirmación antes de mandar el recordatorio de hora por correo desde
// Agenda (botón ✉️, Agenda.jsx) — pedido de Nicolás (20-ago-2026), mismo
// estilo que CancelAppointmentModal.jsx. Antes el botón abría un
// `mailto:` (el staff veía el borrador y decidía mandarlo o no desde su
// propio cliente de correo); ahora el clic manda el correo de verdad por
// Resend (ver notify-appointment-reminder), así que hace falta este paso
// de confirmación en la propia app — si no, un mal clic en un bloque de
// 15 minutos mandaría un correo real sin que nadie lo revise antes.
import { formatPatientName, formatDateLong } from '../lib/format';

export default function SendReminderModal({ appointment, patient, branch, onCancel, onConfirm, loading }) {
  return (
    <div className="modal-overlay">
      <div className="modal-card">
        <h2>Mandar recordatorio</h2>
        <p>
          Se le va a mandar un correo a <strong>{formatPatientName(patient)}</strong> (
          <strong>{patient.email}</strong>) recordándole su hora de <strong>{appointment.type}</strong> el{' '}
          <strong style={{ textTransform: 'capitalize' }}>{formatDateLong(appointment.date)}</strong> a las{' '}
          <strong>{appointment.time?.slice(0, 5)} hrs</strong>
          {branch?.name ? (
            <>
              {' '}
              en <strong>{branch.name}</strong>
            </>
          ) : null}
          .
        </p>
        <div className="modal-actions">
          <button type="button" className="button-secondary" onClick={onCancel} disabled={loading}>
            Volver
          </button>
          <button type="button" className="button-primary" onClick={onConfirm} disabled={loading}>
            {loading ? 'Mandando…' : 'Mandar recordatorio'}
          </button>
        </div>
      </div>
    </div>
  );
}
